import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import memoize from 'react-utils/memoize';
import styled, { css } from 'styled-components';
import { WellContextConsumer } from '../context/WellContext.ts';
import { jsx as _jsx } from "react/jsx-runtime";
const Inner = styled.div.withConfig({
  displayName: "UIWellItem__Inner",
  componentId: "y81cnc-0"
})(["max-width:180px;text-align:center;@supports (display:grid){max-width:none;}"]);
const verticalMixin = css(["display:flex;flex-basis:auto;justify-content:center;"]);
const getStyledWellItem = memoize(WellItemComponent => styled(WellItemComponent).withConfig({
  displayName: "UIWellItem__getStyledWellItem",
  componentId: "y81cnc-1"
})(["position:relative;flex:1 1 180px;padding:0 12px 0 0;margin-top:18px;margin-bottom:32px;", ""], ({
  $orientation
}) => $orientation === 'vertical' && verticalMixin));
export default function UIWellItem(_ref) {
  let {
      children,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(WellContextConsumer, {
    children: ({
      WellItemComponent,
      orientation
    }) => {
      const StyledWellItem = getStyledWellItem(WellItemComponent);
      return /*#__PURE__*/_jsx(StyledWellItem, Object.assign({}, rest, {
        className: classNames('private-well__item', className),
        $orientation: orientation,
        children: /*#__PURE__*/_jsx(Inner, {
          children: children
        })
      }));
    }
  });
}
UIWellItem.propTypes = {
  children: PropTypes.node
};
UIWellItem.displayName = 'UIWellItem';